import { ADJECTIVES_3, NOUNS_2_3 } from "./nicknameWordBank";

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)] as T;
}

/**
 * 词库随机组合，示例：「快乐的」类叠词+名词、「快乐的包子」、双名词等。
 */
export function randomNickname(): string {
  const adj = pick(ADJECTIVES_3);
  const n1 = pick(NOUNS_2_3);
  const n2 = pick(NOUNS_2_3);
  const mode = Math.floor(Math.random() * 4);
  if (mode === 0) {
    return `${adj}的${n1}`;
  }
  if (mode === 1) {
    return `${n1}${n2}`.length <= 6 ? `${n1}${n2}` : `${adj}的${n1}`;
  }
  if (mode === 2) {
    return `${n1}的${n2}`;
  }
  return `${adj}${n1}`;
}
